import { createSlice } from "@reduxjs/toolkit";
import { fetchAllCountry, fetchCountryTableColumnNames, toggleCountryStatus, updateCountry  } from "./thunk";
import { toast } from 'react-toastify';

const initialState = {
  preferences: {},
  country: [],
  tableColumnNames: [],
  loading: false,
  error: null,
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Localization Table Column Names API
      .addCase(fetchCountryTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountryTableColumnNames.fulfilled, (state, action) => {        
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchCountryTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Logs API
      .addCase(fetchAllCountry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCountry.fulfilled, (state, action) => {        
        state.loading = false;
        state.country = action.payload;
      })
      .addCase(fetchAllCountry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Country
      .addCase(updateCountry.pending, (state) => {
        state.error = null;
      })
      .addCase(updateCountry.fulfilled, (state, action) => {
        const index = state.country.findIndex(
          (item) => item.ID === action.payload.ID
        );
  
        if (index >= 0) {
          state.country[index] = action.payload;
        }
      })
      .addCase(updateCountry.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Toggle Country Status API
      .addCase(toggleCountryStatus.pending, (state) => {
        state.error = null;
      })
      .addCase(toggleCountryStatus.fulfilled, (state, action) => {
        
        const index = state.country.findIndex(c => c.ID === action.payload[0]?.ID);
        
        if (index !== -1) {
          state.country[index] = action.payload[0];
        }
      })
      .addCase(toggleCountryStatus.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(action.payload || "Failed to update country status.");
      });
  },
});

export default countrySlice.reducer;
